import background from "../images/background.svg";
import { useEffect, useState } from "react";
import { userService } from "../services/user.service";
import Alert from "../components/Alert";
import { useNavigate } from "react-router-dom";
import AppRoutes  from "../AppRoutes";
import SuccessAlert from "../components/SuccessAlert";

const Register = (props) => {
  const [inputs, setInputs] = useState({});
  const [token, setToken] = useState("");
  const [error, setError] = useState("");
  const [success, setSuccess] = useState("");
  const [processing, setProcessing] = useState(false);
  const navigate = useNavigate();
  const handleChange = (e) =>
    setInputs((prevState) => ({
      ...prevState,
      [e.target.name]: e.target.value,
    }));

  const handleRegisterClick = async (e) => {
    e.preventDefault();
    setProcessing(true);
    setError("");
    setSuccess("");
    const { data, error } = await userService.register({
      token: token,
      email: inputs.email,
      fullName: inputs.fullName,
      password: inputs.password,
      confirmPassword: inputs.confirmPassword,
    });

    if (error){
      setProcessing(false);
      setError(error.message);
      return;
    }
    setSuccess("Please confirm your email by clicking the link in your inbox");
    setProcessing(false);
  };


  useEffect(() => {
    if (success) {
      setTimeout(() => {
        navigate(AppRoutes.UserDash.path);
      }, 10_000);
    }
  }, [, success]);

  return (
    <div className="relative h-screen overflow-hidden bg-indigo-900">
      <img
        alt="background"
        src={background}
        className="absolute h-full w-full object-cover"
      />
      <div className="absolute inset-0 bg-black opacity-25"></div>
      <div className="container relative z-10 mx-auto flex items-center px-6 py-32 md:px-12 xl:py-40">
        <div className="relative z-10 flex w-full flex-col items-center">
          <div className="flex w-full max-w-md flex-col ">
            <div className="flex max-w-md flex-col rounded-lg bg-white px-4 py-8 shadow dark:bg-gray-800 ">
              <div className="mb-2 self-center font-light text-gray-800 dark:text-white sm:text-2xl">
                Create a new account
              </div>
              <span className="flex-items-center justify-center text-center text-sm text-gray-500 dark:text-gray-400">
                Already have an account?&nbsp;
                <a
                  href="/login"
                  className="text-sm text-blue-500 underline hover:text-blue-700"
                >
                  Sign in
                </a>
              </span>
              <div className="mt-8 p-6">
                <form action="#">
                  <div className="mb-2 flex flex-col">
                    <div className="relative flex">
                      <span className="inline-flex items-center  rounded-l-md border-t border-l border-b border-gray-300 bg-white  px-3 text-sm text-gray-500 shadow-sm"></span>
                      <input
                        onChange={handleChange}
                        type="text"
                        name="email"
                        id="email"
                        className=" w-full flex-1 appearance-none rounded-r-lg border border-gray-300 bg-white py-2 px-4 text-base text-gray-700 placeholder-gray-400 shadow-sm focus:border-transparent focus:outline-none focus:ring-2 focus:ring-purple-600"
                        placeholder="Your email"
                      />
                    </div>
                  </div>
                  <div className="mb-2 flex flex-col">
                    <div className=" relative flex ">
                      <span className="inline-flex items-center  rounded-l-md border-t border-l border-b border-gray-300 bg-white  px-3 text-sm text-gray-500 shadow-sm"></span>
                      <input
                        onChange={handleChange}
                        type="text"
                        name="fullName"
                        id="fullName"
                        className=" w-full flex-1 appearance-none rounded-r-lg border border-gray-300 bg-white py-2 px-4 text-base text-gray-700 placeholder-gray-400 shadow-sm focus:border-transparent focus:outline-none focus:ring-2 focus:ring-purple-600"
                        placeholder="Full Name"
                      />
                    </div>
                  </div>
                  <div className="mb-2 flex flex-col">
                    <div className=" relative flex ">
                      <span className="inline-flex items-center  rounded-l-md border-t border-l border-b border-gray-300 bg-white  px-3 text-sm text-gray-500 shadow-sm"></span>
                      <input
                        onChange={handleChange}
                        type="password"
                        name="password"
                        id="password"
                        className=" w-full flex-1 appearance-none rounded-r-lg border border-gray-300 bg-white py-2 px-4 text-base text-gray-700 placeholder-gray-400 shadow-sm focus:border-transparent focus:outline-none focus:ring-2 focus:ring-purple-600"
                        placeholder="Password"
                      />
                    </div>
                  </div>
                  <div className="mb-2 flex flex-col">
                    <div className=" relative flex ">
                      <span className="inline-flex items-center  rounded-l-md border-t border-l border-b border-gray-300 bg-white  px-3 text-sm text-gray-500 shadow-sm"></span>
                      <input
                        onChange={handleChange}
                        type="password"
                        name="confirmPassword"
                        id="confirmPassword"
                        className=" w-full flex-1 appearance-none rounded-r-lg border border-gray-300 bg-white py-2 px-4 text-base text-gray-700 placeholder-gray-400 shadow-sm focus:border-transparent focus:outline-none focus:ring-2 focus:ring-purple-600"
                        placeholder="Confirm password"
                      />
                    </div>
                  </div>
                  <div className="my-4 mx-auto flex w-full justify-center">
                    <button
                      onClick={handleRegisterClick}
                      type="button"
                      className="ico disabled:true flex min-w-max items-center rounded-lg bg-emerald-700 px-10 py-2 text-white hover:cursor-pointer hover:bg-emerald-600 disabled:bg-gray-600"
                      disabled={processing}
                    >
                      {processing && (
                        <svg
                          className="mr-3 h-5 w-5 animate-spin text-white"
                          xmlns="http://www.w3.org/2000/svg"
                          fill="none"
                          viewBox="0 0 24 24"
                        >
                          <circle
                            className="opacity-25"
                            cx="12"
                            cy="12"
                            r="10"
                            stroke="currentColor"
                            strokeWidth="4"
                          ></circle>
                          <path
                            className="opacity-75"
                            fill="currentColor"
                            d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
                          ></path>
                        </svg>
                      )}
                      <span className="font-normal">
                        {processing ? "Working..." : "Register"}
                      </span>
                    </button>
                  </div>
                  {error && <Alert message={error} />}
                  {success && <SuccessAlert message={success} />}
                </form>
                <div className="mt-6 flex items-center justify-center"></div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Register;
